var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreeSetup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 629,
    viewBox: "0 0 1280 629",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400 1H561.569C567.075 1 572.528 2.08458 577.615 4.19181C582.703 6.29904 587.325 9.38765 591.219 13.2813C595.112 17.175 598.201 21.7974 600.308 26.8847C602.415 31.972 603.5 37.4245 603.5 42.931V253",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M880 1H719.361C708.241 1.00027 697.575 5.4181 689.712 13.2817C681.849 21.1452 677.431 31.8104 677.431 42.931V293",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M400 240.875H880",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M629.5 429V287",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M648.5 343.5C707.318 343.5 755 295.818 755 237C755 178.182 707.318 130.5 648.5 130.5C589.682 130.5 542 178.182 542 237C542 295.818 589.682 343.5 648.5 343.5Z",
    fill: "#000011",
    stroke: "url(#paint0_linear_39_19)",
    strokeWidth: 1.054,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M676.387 293.61C673.433 293.614 670.488 293.301 667.601 292.679C662.954 291.645 658.695 289.317 655.316 285.963C646.698 290.635 636.749 294.016 626.216 292.409C618.305 291.2 609.402 285.427 608.139 272.847C607.736 268.783 607.769 264.688 608.239 260.631C603.426 259.38 598.844 257.366 594.668 254.666C582.938 247.18 578.168 232.337 581.591 213.944C584.025 200.85 597.637 182.118 612.211 176.644C619.583 173.877 626.723 174.789 632.311 179.21C634.23 180.631 635.818 182.45 636.967 184.542C638.116 186.635 638.798 188.952 638.967 191.333C639.516 200.355 632.642 208.044 630.522 210.186C623.398 217.386 614.873 220.061 604.45 218.376C603.676 218.259 602.933 217.989 602.264 217.583C601.595 217.176 601.013 216.641 600.552 216.009C600.09 215.376 599.759 214.658 599.577 213.897C599.395 213.136 599.366 212.346 599.491 211.573C599.616 210.8 599.894 210.06 600.307 209.395C600.72 208.73 601.26 208.153 601.898 207.699C602.535 207.244 603.256 206.92 604.019 206.746C604.782 206.571 605.572 206.55 606.344 206.683C612.972 207.759 617.69 206.313 622.103 201.854C624.238 199.696 627.342 195.307 627.144 192.054C627.089 191.159 626.792 189.947 624.966 188.503C623.495 187.341 621.005 185.995 616.366 187.735C606.205 191.549 594.966 206.777 593.229 216.106C590.737 229.506 593.582 239.923 601.029 244.678C604.006 246.605 607.26 248.063 610.68 249.002C613.58 239.519 618.703 229.702 626.114 219.411C633.607 209.002 644.077 196.68 658.653 193.78C663.467 192.724 668.503 193.609 672.668 196.242C676.834 198.875 679.794 203.045 680.905 207.846C682.662 216.405 678.299 226.724 670.292 232.946C668.441 234.383 666.61 235.819 664.799 237.254C655.626 244.484 646.14 251.961 635.042 257.705C630.384 260.126 625.264 261.526 620.023 261.814C619.628 265.085 619.592 268.389 619.916 271.667C620.608 278.56 625.275 280.286 627.995 280.702C635.03 281.776 642.19 279.454 648.712 276.057C644.521 264.978 650.872 251.524 658.681 243.586C662.866 239.33 669.874 232.206 679.93 234.559C681.79 235.018 683.531 235.867 685.039 237.049C686.547 238.231 687.786 239.72 688.676 241.417C689.723 243.275 690.375 245.328 690.592 247.45C690.808 249.571 690.585 251.714 689.936 253.745C685.962 265.289 674.936 273.007 666.071 279.208L665.876 279.345C667.171 280.18 668.605 280.776 670.11 281.105C674.42 282.042 678.882 282.025 683.185 281.055C687.488 280.086 691.526 278.187 695.018 275.493C697.368 273.712 699.279 271.416 700.602 268.781C701.925 266.145 702.626 263.242 702.651 260.293C702.671 258.736 703.304 257.249 704.413 256.155C705.521 255.06 707.016 254.447 708.573 254.447C710.131 254.447 711.626 255.06 712.734 256.155C713.843 257.249 714.476 258.736 714.496 260.293C714.479 265.012 713.385 269.665 711.298 273.898C709.211 278.13 706.186 281.831 702.453 284.718C695.012 290.531 685.829 293.664 676.387 293.61ZM676.052 245.949C673.752 245.949 671.345 247.604 667.129 251.89C662.491 256.606 658.748 263.952 659.268 269.513L659.284 269.502C666.74 264.284 676.02 257.79 678.74 249.889C678.951 248.954 678.799 247.973 678.315 247.146C678.103 246.671 677.719 246.294 677.24 246.091C676.851 245.998 676.452 245.95 676.052 245.949ZM662.615 205.232C662.062 205.234 661.51 205.29 660.968 205.4C650.33 207.517 641.468 218.361 635.731 226.334C630.438 233.429 626.156 241.224 623.007 249.497C625.303 249.039 627.523 248.26 629.602 247.182C639.702 241.958 648.331 235.154 657.47 227.949C659.309 226.501 661.163 225.047 663.032 223.588C667.393 220.202 670.149 214.335 669.306 210.231C668.893 208.779 668.015 207.503 666.806 206.6C665.597 205.697 664.124 205.216 662.615 205.232Z",
    fill: "url(#paint1_linear_39_19)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M681.632 258.075C680.499 257.002 678.985 256.423 677.425 256.466C675.865 256.509 674.386 257.17 673.313 258.303C669.313 262.531 663.996 266.251 659.306 269.533L659.241 269.578C659.319 270.448 659.525 271.301 659.852 272.111C661.083 275.056 663.158 277.572 665.815 279.341L666.054 279.176C671.202 275.576 677.038 271.489 681.86 266.394C682.933 265.261 683.511 263.747 683.469 262.187C683.426 260.627 682.765 259.148 681.632 258.075Z",
    fill: "url(#paint2_linear_39_19)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M648.983 276.625C648.907 276.441 648.841 276.254 648.77 276.067C642.232 279.478 635.049 281.815 627.994 280.737C627.229 280.617 626.447 280.65 625.694 280.833C624.942 281.015 624.232 281.345 623.607 281.803C622.982 282.26 622.454 282.837 622.052 283.499C621.65 284.162 621.383 284.897 621.266 285.663C621.149 286.428 621.185 287.21 621.37 287.962C621.556 288.714 621.888 289.422 622.348 290.045C622.808 290.669 623.387 291.195 624.051 291.594C624.715 291.994 625.451 292.258 626.217 292.372C627.998 292.641 629.796 292.775 631.597 292.772C640.136 292.772 648.187 289.782 655.324 285.909C652.616 283.265 650.461 280.109 648.983 276.625Z",
    fill: "url(#paint3_linear_39_19)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M610.7 249.09C607.272 248.154 604.013 246.683 601.043 244.733C599.733 243.884 598.139 243.591 596.613 243.917C595.086 244.243 593.752 245.163 592.903 246.473C592.054 247.783 591.761 249.377 592.087 250.903C592.413 252.43 593.333 253.764 594.643 254.613C598.824 257.355 603.427 259.392 608.268 260.644C608.726 256.727 609.54 252.86 610.7 249.09Z",
    fill: "url(#paint4_linear_39_19)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M649.408 241.757C648.528 240.468 647.172 239.582 645.638 239.292C644.105 239.003 642.519 239.334 641.23 240.214C637.506 242.782 633.628 245.119 629.619 247.214C627.516 248.304 625.271 249.093 622.949 249.558C621.506 253.516 620.517 257.624 620 261.805C625.247 261.506 630.371 260.096 635.033 257.669C639.465 255.355 643.752 252.772 647.869 249.935C648.507 249.499 649.053 248.942 649.476 248.295C649.898 247.648 650.189 246.924 650.332 246.165C650.475 245.405 650.467 244.625 650.309 243.869C650.15 243.113 649.844 242.395 649.408 241.757Z",
    fill: "url(#paint5_linear_39_19)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_39_19",
    x1: 541.473,
    y1: 237,
    x2: 755.527,
    y2: 237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9E360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#F09D4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE4030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_39_19",
    x1: 580.5,
    y1: 234.344,
    x2: 714.5,
    y2: 234.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9E360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#F09D4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE4030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_39_19",
    x1: 651.109,
    y1: 282.551,
    x2: 675.948,
    y2: 264.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_39_19",
    x1: 655.036,
    y1: 281.634,
    x2: 631.264,
    y2: 286.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_39_19",
    x1: 613.519,
    y1: 258.257,
    x2: 598.442,
    y2: 249.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_39_19",
    x1: 607.842,
    y1: 260.508,
    x2: 651.103,
    y2: 244.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeSetup);
export default __webpack_public_path__ + "static/media/tree-setup.0d84784077a205ee0a5db6f3e2f656cb.svg";
export { ForwardRef as ReactComponent };